// extracted by mini-css-extract-plugin
export default {"switch":"GlobalSwitch_switch__LRpmw","slider":"GlobalSwitch_slider__TLUfO","disabled":"GlobalSwitch_disabled__0RnJk"};